import { Component } from '@theme/component';

/**
 * Opens/closes the product-page BTU dialog. The calculator inside is the
 * shared <cr-btu-calculator> component.
 *
 * @extends {Component<{ dialog: HTMLDialogElement }>}
 */
class CrBtuHelper extends Component {
  requiredRefs = ['dialog'];

  connectedCallback() {
    super.connectedCallback();
    this.refs.dialog.addEventListener('click', this.#onBackdropClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.dialog.removeEventListener('click', this.#onBackdropClick);
  }

  open() {
    this.refs.dialog.showModal();
    this.refs.dialog.querySelector('input')?.focus();
  }

  close() {
    this.refs.dialog.close();
  }

  /** @param {MouseEvent} event */
  #onBackdropClick = (event) => {
    if (event.target === this.refs.dialog) this.close();
  };
}

if (!customElements.get('cr-btu-helper')) customElements.define('cr-btu-helper', CrBtuHelper);
